<script lang="ts">
    import queryString from "query-string";
    import Footer from "../footer/Footer.svelte";
    import Head from "../header/Head.svelte";
    import Navbar from "../header/Navbar.svelte";
    import { _ } from "svelte-i18n";
    import countries from "../shared/country-select/countries";
    import Select from "svelte-select";
    import { onMount } from "svelte";

    export let plan: "individual" | "team" = "individual";

    let yearly: boolean = true;
    let country: {value: string, label: string} = undefined;
    let items:  {value: string, label: string}[] = countries.map(x => { return { value: x.code, label: x.name }});

    let getBuyDetails = () => {
        const parsed = queryString.parse(window.location.search);

        if (parsed.plan === "individual") plan = "individual";
        if (parsed.plan === "team") plan = "team";
        if (parsed.yearly === "true") yearly = true;
        if (parsed.yearly === "false") yearly = false;

        return true;
    }

    onMount(() => {
        getBuyDetails();
    });
</script>

<svelte:head>
    <title>ANYWAYS | {$_(`buy.${plan}.pagetitle`)}</title>
</svelte:head>

<Navbar background={"light"} isFluid={false} />

<section class="pt-8 pt-md-11 pb-8 pb-md-14">
    <div class="container">
        <div class="row justify-content-center">
            <div class="col-12 col-md-10 col-lg-8 text-center">
                <h2 class="font-weight-bold">{$_(`buy.${plan}.title`)}</h2>

                <p class="font-size-lg text-muted">
                    {$_(`buy.${plan}.description`)}
                </p>

                <p class="font-size-lg text-muted mb-7 mb-md-9" />
            </div>
        </div>

        <div class="row justify-content-center">
            <div class="col-12 col-md-12 col-lg-10">
                <form
                    name="sentMessage"
                    id="buyForm"
                    action="https://formspree.io/f/xnnnonlp"
                    method="POST"
                    novalidate>
                    <div class="row">
                        <div class="col-6">
                            <div class="form-group mb-5">
                                <label for="name">{$_("buy.form.company.label")}</label>
                                <input
                                    type="text"
                                    class="form-control"
                                    name="name"
                                    id="name"
                                    required
                                    data-validation-required-message="{$_("buy.form.company.message")}"
                                    placeholder="{$_("buy.form.company.placeholder")}" />
                            </div>
                        </div>
                        <div class="col-6">
                            <div class="form-group mb-5">
                                <label for="name">{$_("buy.form.vat.label")}</label>
                                <input
                                    type="text"
                                    class="form-control"
                                    name="vat"
                                    id="vat"
                                    required
                                    data-validation-required-message="{$_("buy.form.vat.message")}"
                                    placeholder="{$_("buy.form.vat.placeholder")}" />
                            </div>
                        </div>
                        <div class="col-12">
                            <div class="form-group mb-5">
                                <label for="name">{$_("buy.form.yearly.label")}</label>
                                <input
                                    class="form-check-input"
                                    type="checkbox"
                                    bind:checked={yearly}
                                    name="yearly"
                                    id="yearly"
                                    required
                                    data-validation-required-message="{$_("buy.form.yearly.message")}"
                                    placeholder="{$_("buy.form.yearly.placeholder")}" />
                                    <p class="font-size-lg text-muted">
                                        {#if yearly}
                                            {$_(`buy.${plan}.yearly.explainer`)}
                                        {:else}
                                            {$_(`buy.${plan}.monthly.explainer`)}
                                        {/if}
                                    </p>
                            </div>
                        </div>
                        <div class="col-12 col-md-6">
                            <div class="form-group mb-5">
                                <label for="billingName">{$_("buy.form.billingName.label")}</label>
                                <input
                                    type="text"
                                    class="form-control"
                                    name="billingName"
                                    id="billingName"
                                    required
                                    data-validation-required-message="{$_("buy.form.billingName.message")}"
                                    placeholder="{$_("buy.form.billingName.placeholder")}" />
                            </div>
                        </div>
                        <div class="col-12 col-md-6">
                            <div class="form-group mb-5">
                                <label for="billingEmail">{$_("buy.form.billingEmail.label")}</label>
                                <input
                                    type="email"
                                    class="form-control"
                                    name="billingEmail"
                                    id="billingEmail"
                                    required
                                    data-validation-required-message="{$_("buy.form.billingEmail.message")}"
                                    placeholder="{$_("buy.form.billingEmail.placeholder")}" />
                            </div>
                        </div>
                        <div class="col-12">
                            <div class="form-group mb-5">
                                <label for="streetAndNumber">{$_("buy.form.streetAndNumber.label")}</label>
                                <input
                                    type="text"
                                    class="form-control"
                                    name="streetAndNumber"
                                    id="streetAndNumber"
                                    required
                                    data-validation-required-message="{$_("buy.form.streetAndNumber.message")}"
                                    placeholder="{$_("buy.form.streetAndNumber.placeholder")}" />
                            </div>
                        </div>
                        <div class="col-12 col-md-6">
                            <div class="form-group mb-5">
                                <label for="city">{$_("buy.form.city.label")}</label>
                                <input
                                    type="text"
                                    class="form-control"
                                    name="city"
                                    id="city"
                                    required
                                    data-validation-required-message="{$_("buy.form.city.message")}"
                                    placeholder="{$_("buy.form.city.placeholder")}" />
                            </div>
                        </div>
                        <div class="col-12 col-md-6">
                            <div class="form-group mb-5">
                                <label for="postcode">{$_("buy.form.postcode.label")}</label>
                                <input
                                    type="text"
                                    class="form-control"
                                    name="postcode"
                                    id="postcode"
                                    required
                                    data-validation-required-message="{$_("buy.form.postcode.message")}"
                                    placeholder="{$_("buy.form.postcode.placeholder")}" />
                            </div>
                        </div>
                        <div class="col-12">
                            <div class="form-group mb-7 mb-md-9">
                                <label for="country">
                                    {$_("buy.form.country.label")}
                                </label>
                                <Select {items} bind:selectedValue={country} inputAttributes={{ name: "country", type:"text" }}>
                                </Select>
                            </div>
                        </div>
                        <input name="plan" type="hidden" value={plan} >
                        <input name="yearly" type="hidden" value={true} >
                    </div>
                    <div class="row justify-content-center">
                        <div class="col-auto">
                            <button
                                type="submit"
                                value="Send"
                                class="btn btn-primary lift">
                                {$_(`buy.${plan}.form.submit`)}
                            </button>
                        </div>
                    </div>
                </form>
            </div>
        </div>
    </div>
</section>

<div class="position-relative">
    <div class="shape shape-bottom shape-fluid-x text-dark">
        <svg
            viewBox="0 0 2880 48"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            ><path
                d="M0 48h2880V0h-720C1442.5 52 720 0 720 0H0v48z"
                fill="currentColor" /></svg>
    </div>
</div>

<Footer bgClass="bg-dark" />
